import { combineReducers } from 'redux';
import storageSession from 'redux-persist/lib/storage/session';
import { deleteGroup, getRealizedGain } from './groups.reducer';
import {
    addGroups,
    addLot,
    addSymbol,
    allInstallments,
    allWithdrawals,
    cashIn,
    cashOut,
    changeEmail,
    changePassword,
    confirmPassword,
    createdUser,
    deleteLots,
    deleteSymbol,
    deleteUser,
    getCash,
    getGroup,
    getGroups,
    getGroupSymbol,
    getLotsList,
    getSymbols,
    getTotalFund,
    installments,
    loginReducer,
    modals,
    newUser,
    passwordRecoveryReducer,
    resetPasswordReducer,
    sellLot,
    transactctions,
    updateGroup,
    updateProfile,
    userData,
    userHolding,
    userInfo,
    users,
    withdrawals,
} from './index';

const modalsPersistConfig = { key: 'modals', storage: storageSession };

const reducer = combineReducers({
    modals: modals,
    loginReducer,
    passwordRecoveryReducer,
    resetPasswordReducer,
    userInfo,
    userData,
    changeEmail,
    changePassword,
    confirmPassword,
    newUser,
    users,
    installments,
    withdrawals,
    updateProfile,
    deleteUser,
    createdUser,
    allInstallments,
    allWithdrawals,
    addGroups,
    updateGroup,
    getGroup,
    getGroupSymbol,
    getGroups,
    getSymbols,
    addSymbol,
    getLotsList,
    deleteLots,
    addLot,
    sellLot,
    deleteSymbol,
    deleteGroup,
    getCash,
    getRealizedGain,
    getTotalFund,
    cashIn,
    cashOut,
    userHolding,
    transactctions,
});

export default reducer;
